import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 shadow-lg border-b border-amber-600/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400 bg-clip-text text-transparent tracking-wide" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
              METAL LINK
            </h1>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="/" className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer">
              ホーム
            </a>
            <a href="/services" className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer">
              サービス紹介
            </a>
            <a href="/introduction" className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer">
              紹介業務
            </a>
            <a href="/company" className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer">
              会社概要
            </a>
            <a href="/contact" className="text-gray-300 hover:text-amber-400 transition-colors cursor-pointer">
              お問い合わせ
            </a>
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-300 hover:text-amber-400 focus:outline-none cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-amber-600/30">
            <nav className="flex flex-col space-y-4">
              <a href="/" className="text-gray-300 hover:text-amber-400 font-medium transition-colors cursor-pointer">
                ホーム
              </a>
              <a href="/services" className="text-gray-300 hover:text-amber-400 font-medium transition-colors cursor-pointer">
                サービス
              </a>
              <a href="/introduction" className="text-gray-300 hover:text-amber-400 font-medium transition-colors cursor-pointer">
                紹介業務
              </a>
              <a href="/company" className="text-gray-300 hover:text-amber-400 font-medium transition-colors cursor-pointer">
                会社概要
              </a>
              <a href="/contact" className="text-gray-300 hover:text-amber-400 font-medium transition-colors cursor-pointer">
                お問い合わせ
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
